var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6364 26.6667H8.36364C8.07431 26.6667 7.79683 26.5523 7.59225 26.3487C7.38766 26.145 7.27273 25.8689 7.27273 25.5809V15.8091H4L15.2658 5.61602C15.4667 5.43413 15.7285 5.33333 16 5.33333C16.2715 5.33333 16.5333 5.43413 16.7342 5.61602L28 15.8091H24.7273V25.5809C24.7273 25.8689 24.6123 26.145 24.4078 26.3487C24.2032 26.5523 23.9257 26.6667 23.6364 26.6667ZM9.45455 24.4952H22.5455V13.8081L16 7.88634L9.45455 13.8081V24.4952ZM11.6364 20.1521H20.3636V22.3236H11.6364V20.1521Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome2);
export default __webpack_public_path__ + "static/media/home2.d7e084f794dbf36002bd9e19ce302452.svg";
export { ForwardRef as ReactComponent };